export default function imageLoader({ src }) {
  return `${
    src?.startsWith('http') ? '' : process.env.NEXT_PUBLIC_STATIC_URL
  }${src}`;
}
